module.exports = __webpack_public_path__ + "static/media/img176.7b59bd83.jpg";